import React from 'react';
import styled from "styled-components";
import {ReactComponent as Icon} from '../assets/icons/iconmonstr-pencil-line-filled.svg';


const IconoUpdate = styled(Icon)`
height: 20px;
fill: #fff;
`


const IconUpdate = () => {
    return ( 
        <>
            <IconoUpdate></IconoUpdate>
        </>
     );
}
 
export default IconUpdate;